import { generateNextgenImageUrl } from "./../utilities/utils";
import ImageGalleryMobile from "./../../touch/reader/components/imageGallery/imageGalleryMobile";
import NextgenSharing from "./nextGenSharing";
import ImageGallery from "./imageGallery";
import * as eventNames from "./../analytics/analyticsevents";

const {
  client_fullname,
} = require(`./../../../clients/${process.env.CLIENT}/package.json`);

/**
 * This is class with methods that allows integration
 * between webapp and nextgen. The instance of this class should be exposed
 * as property on window object, to make it available for nextgen
 * app.
 */
export default class Bridge {
  constructor(appState, pubStore, options) {
    this._appState = appState;
    this._pubStore = pubStore;
    this._options = options;
  }

  editionReady(pages) {
    this._pubStore.loadPagesFromReader(pages);
  }

  getTDMPattern() {
    return this._appState.cdnAssetsDownloader.getTDMPattern();
  }

  onPageAccess(pageIndex) {
    this.setupPage(pageIndex);
    if (pageIndex !== this._appState.currentPage) {
      this._appState.changeCurrentPage(pageIndex);
    }
  }

  openImageViewer(data) {
    data.images.forEach((image) => {
      image.src = generateNextgenImageUrl(
        this._pubStore.CPackage.ContentPackageID,
        image.FileName
      );
      image.srcHD = image.src;
      image.HtmlText = image.Caption;
    });
    if (this._appState.isDesktop) {
      new ImageGallery({
        appState: this._appState,
        slideNumber: 0,
        context: data,
        options: this._options.imageviewer,
      });
    } else {
      new ImageGalleryMobile({
        appState: this._appState,
        slideNumber: 0,
        context: data,
        options: this._options.imageviewer,
      });
    }
  }

  getSharedArticleDetails(data) {
    let sharingContainer;
    var currentPageId = "#page" + this._appState.currentPage;
    var currentpage = document.querySelector(currentPageId);
    const articleToShare = currentpage.querySelectorAll(
      "[data-article-id='" + data.ContentId + "']"
    );
    if (data.Family == "tmgFamily") {
      if (this.hasSharingContainer(articleToShare[0])) {
        sharingContainer = articleToShare[0].querySelector(".sharing-menu");
      } else if (this.hasSharingContainer(articleToShare[0].parentElement)) {
        sharingContainer =
          articleToShare[0].parentElement.querySelector(".sharing-menu");
      } else {
        sharingContainer =
          articleToShare[0].parentElement.parentElement.querySelector(
            ".sharing-menu"
          );
      }
    } else {
      if (articleToShare[0]) {
        sharingContainer = articleToShare[0].querySelector(".sharing-menu");
      }
    }
    if (sharingContainer) {
      if (sharingContainer.classList.contains("hidden")) {
        this.nextgenSharingController = new NextgenSharing(
          this._appState,
          data,
          sharingContainer,
          this._options.sharing
        );
        sharingContainer.addEventListener("click", (e) => {
          this.nextgenSharingController.close(e);
        });
      } else {
        sharingContainer.classList.add("hidden");
      }
    }
  }

  hasSharingContainer(parent) {
    return parent.querySelector(".sharing-menu");
  }

  getEnvironmentData() {
    const data = {
      SubscriptionReference: this._appState.subscriptionReference,
      SubscriptionUserReference: this._appState.userInfo.userReference,
      DeviceReference: this._appState.uuid,
      DeviceType: "webApp",
      AppName: client_fullname,
    };

    if (
      window.app !== "undefined" &&
      window.app.platform !== "undefined" &&
      typeof window.app.platform.gotEnvironmentData === "function"
    ) {
      window.app.platform.gotEnvironmentData(data);
    }
  }

  getUserNavigationData() {
    const data = {
      userSubscription: {},
    };

    // @todo here there will be also METERED added at some point
    if (this._appState.isLoggedIn) {
      data.userSubscription.type = "SUBSCRIPTION";
    } else {
      data.userSubscription.type = "ANONYMOUS";
    }

    // @todo when freemium added, implement freemiumModelData -> see old webreader implementation
    // @todo when metered added, implement meteredModelData -> see old webreader implementation

    if (
      window.app !== "undefined" &&
      window.app.platform !== "undefined" &&
      typeof window.app.platform.gotUserNavigationData === "function"
    ) {
      window.app.platform.gotUserNavigationData(data);
    }
  }

  getPublicationDetails() {
    const publicationDetails = {
      cpId: this._pubStore.cpID,
      pubId: this._pubStore.pubId,
      pageNumber: this._appState.currentPage,
      pageUrl: window.location.href,
    };

    if (
      window.app !== "undefined" &&
      window.app.platform !== "undefined" &&
      typeof window.app.platform.gotUserNavigationData === "function"
    ) {
      window.app.platform.gotPublicationDetails(publicationDetails);
    }
  }

  openExternalAuthenticationPopup() {
    // @todo open external authentication popup
  }

  redirectToHome() {
    if (this._options.nextgen.redirectUrl) {
      window.open(this._options.nextgen.redirectUrl);
    }
  }

  setPageTitle(title) {
    document.title = title;
  }

  shouldDisplayAds(subscriptionTypeAdvertised) {
    const userSubscriptionType = this._appState.getUserSubscriptionType();
    return subscriptionTypeAdvertised.indexOf(userSubscriptionType) !== -1;
  }

  addCurrentPageToCredits() {
    const userSubscriptionType = this._appState.getUserSubscriptionType();
    if (userSubscriptionType !== "METERED") {
      // @todo implement -> see readerApp.freemium.addFreePage function call in old webreader
    }
  }

  ERSendEvent(data, eventOrigin, isNextgenEvent = false) {
    this._appState.setActiveNextgenPage(data, true);
    const nextgenData = { nextgenEvent: isNextgenEvent };
    this._appState.triggerEvent(
      eventNames.PERCENTAGE_IN_VIEW_COMPUTED,
      nextgenData,
      true
    );
  }

  sendGoogleInfo(event, eventData) {
    let eventName = "";
    if (typeof event === "object") {
      eventName = eventNames.VIEW_PAGE_NEXGEN;
      this.setupPage(event.page - 1);
    } else {
      eventName = eventNames[event];
    }

    // @todo send data with Google Tag Manager depending on settings
    this._appState.triggerEvent(eventName, eventData, true);
  }

  sendGoogleEventInfo() {
    // @todo send data with Google Tag Manager
  }

  setupPage(pageIndex) {
    const page = this._pubStore.getCurrentPages(pageIndex);
    if (page) this._appState.setActiveNextgenPage(page);
  }
}



// WEBPACK FOOTER //
// ./src/common/components/bridge.js